import { TaxDocumentType } from "../../types";

export enum TaxFormType {
  W9 = "W9",
  W8 = "W8",
}

export enum TaxFormDisplayName {
  W9 = "W9 (US vendors)",
  W8 = "W8-BEN (Foreign vendors)",
}

export const TAX_FORM_DISPLAY_NAMES = {
  [TaxFormType.W9]: TaxFormDisplayName.W9,
  [TaxFormType.W8]: TaxFormDisplayName.W8,
};

export const DOCUMENT_TYPE_TO_FORM_TYPE = {
  [TaxDocumentType.US_TAX]: TaxFormType.W9,
  [TaxDocumentType.NON_US_TAX]: TaxFormType.W8,
};

export const FORM_TYPE_TO_DOCUMENT_TYPE = {
  [TaxFormType.W9]: TaxDocumentType.US_TAX,
  [TaxFormType.W8]: TaxDocumentType.NON_US_TAX,
};
